<template>
  <base-section
    id="mccluskey"
  >
    <base-section-heading
      title="McCluskey Doctoral Thesis Award"
    />
    <v-container>
      <base-section-heading
      divider=null
      >
      The TTTC’s Doctoral Thesis Award, named after Prof. E. J. McCluskey, promotes the most impactful doctoral student work, provides the students with exposure to the community and prospective employers, and supports interaction between academia and industry in the field of test technology.
      The contest is held in two stages: semi-finals and finals.
      Semi-finals will be held at the IEEE Asian Test Symposium (ATS), IEEE VLSI Test Symposium (VTS), the <strong>IEEE European Test Symposium (ETS)</strong>, and the IEEE Latin American Test Symposium (LATS).
      At each semi-final, a jury composed of industrial and academic experts will determine the winner. The four semi-final winners will compete against each other in the finals, held at the International Test Conference (ITC) 2023.
      <br> The thesis may cover, but is not limited to, the list of topics related to the ETS core scientific areas as outlined in the ETS'23 Call for Papers.
      <br>
      <br>
      <v-btn
        href="#/program#tab-topics"
        target="_parent"
        rounded
        color="primary"
        dark
        style="padding: 15px"
        v-if="!isMobileDevice()"
      >
        <v-icon
          left
          dark
        >
          mdi-open-in-new
        </v-icon>
        List of the Topics
      </v-btn>
      <v-btn
        href="#/topics"
        target="_parent"
        rounded
        color="primary"
        dark
        style="padding: 15px"
        v-else
      >
        <v-icon
          left
          dark
        >
          mdi-open-in-new
        </v-icon>
        List of the Topics
      </v-btn>
      <br>
      <br>
      <v-btn
          href="https://welcome.molesystems.com/tttc/ETS/2023/"
          target="_blank"
          rounded
          color="green"
          dark
          download
          style="padding: 15px"
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          Link to the Sumissions website
      </v-btn>
      </base-section-heading>
      <base-section-heading
      title="Eligibility"
      >
      It is open for Ph.D. students that defended their thesis after April 2021 or will defend before December 2023. The winner is announced at ETS'23 closing and their paper will be included in the formal proceedings.
      </base-section-heading>
      <base-section-heading
      title="Publications"
      >
      The winner's paper will be included in the formal proceedings of ETS'23.
      </base-section-heading>
      <base-section-heading
      title="Guidelines for Authors"
      >
      <div style="text-align: left !important">
      By submitting a contribution, the authors agree to register and present at ETS 2023 in case of acceptance. Interested PhD students are invited to submit electronically <a href="https://welcome.molesystems.com/tttc/ETS/2023/">here</a> a single PDF file consisting of: <br>
      ●	A cover letter filled with the PhD information given in the <a
      href="ETS23_McCluskey_Award_Cover_Letter_and_Paper_Guidelines.docx"
      download
      >template</a> <br>
      ●	A paper of 10 pages (IEEE conference paper <a
      href="https://www.ieee.org/conferences/publishing/templates.html"
      target="_blank"
      >style</a> with a minimum font size of 10pt including tables) summarizing the thesis work, based on the guidelines you can find on the <a
      href="ETS23_McCluskey_Award_Cover_Letter_and_Paper_Guidelines.docx"
      download
      >template</a>. <br>
      </div>
      </base-section-heading>
      <base-section-heading
      title="McCluskey Award Template"
      >
      You can download the <span style="color:red"><strong>mandatory</strong></span> template for the cover letter <a
      href="ETS23_McCluskey_Award_Cover_Letter_and_Paper_Guidelines.docx"
      download
      >here</a>.
      <br>
      <br>
        <v-btn
          href="ETS23_McCluskey_Award_Cover_Letter_and_Paper_Guidelines.docx"
          target="_blank"
          rounded
          color="primary"
          dark
          download
          style="padding: 15px"
          class="btn-multiline"
        >
          <v-icon
            left
            dark
          >
            mdi-cloud-download
          </v-icon>
          <p class="text-wrap ma-auto">
          Download the template for the cover letter
          </p>
        </v-btn>
      </base-section-heading>
      <base-section-heading
      title="Key Dates"
      >
      <v-data-table
        :headers="headers"
        :items="dates"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:[`item.date`]="{ item }">
          <span
          v-html="item.date"
          >
          </span>
        </template>
      </v-data-table>
      <br>
      <br>
      <v-btn
          href="https://welcome.molesystems.com/tttc/ETS/2023/"
          target="_blank"
          rounded
          color="green"
          dark
          download
          style="padding: 15px"
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          Link to the Sumissions website
      </v-btn>
      </base-section-heading>
      <base-section-heading
      title="Contacts"
      >
      <v-row>
        <v-col
          v-for="(contest, i) in contests"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="contest"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      </base-section-heading>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in studentsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < studentsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Mccluskey',

    data: () => ({
      isMobile: false,
      studentsfooter: [
        {
          name: 'Student Activities at ETS23',
          url: 'student-activities-23',
        },
        {
          name: 'Best Student Presentation Award',
          url: 'bspa',
        },
        {
          name: 'PhD Forum',
          url: 'student-phd-forum',
        },
        {
          name: 'McCluskey Award',
          url: 'mccluskey',
        },
        {
          name: 'Test Spring School',
          url: 'tss',
        },
        {
          name: 'Student Activities at ETS22',
          url: 'student-activities-22',
        },
      ],
      contests: [
        {
          title: 'Anne Meixner',
          src: require('@/images/committees/meixner.jpg'),
          text: 'ENG.DAUGHTERS, US',
        },
        {
          title: 'Arnaud Virazel',
          src: require('@/images/committees/arnaud.jpg'),
          text: 'LIRMM, FR',
        },
      ],
      headers: [
        {
          text: 'Deadline Date',
          value: 'date',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Type',
          value: 'name',
          sortable: false,
          align: 'left',
        },
      ],
      dates: [
        {
          name: 'McCluskey submissions',
          date: '<s>15 January 2023</s> <strong>30 January 2023</strong> (<span style="color: red;"><strong>Extended Deadline</strong></span>)',
        },
        {
          name: 'Papers Notification',
          date: '6 February 2023',
        },
      ],
    }),
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
<style>
.btn-multiline > span {
  width: 100%
}
</style>
